var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"button",class:{
    primary: _vm.primary,
    secondary: _vm.secondary,
    outlined: _vm.outlined,
    full: _vm.full,
    small: _vm.small,
    danger: _vm.danger
  },attrs:{"disabled":_vm.loading || _vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[(!_vm.loading)?[_vm._t("default")]:[_vm._m(0)]],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-5"},[_c('i',{staticClass:"fas fa-spinner fa-spin"})])
}]

export { render, staticRenderFns }